import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MedicalOfficesSearchResult } from 'src/app/core/api';

@Component({
  standalone: false,
  selector: 'ssc-medical-office-address',
  templateUrl: './medical-office-address.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MedicalOfficeAddressComponent {
  @Input() public medicalOffice: MedicalOfficesSearchResult;
  @Input() public medicalOfficeNameIsLarge: boolean = false;

  public getLocation(): string {
    const { address } = this.medicalOffice;
    return address.house_number
      ? `${address.street} ${address.house_number}, ${address.zip_code} ${address.city}`
      : `${address.street}, ${address.zip_code} ${address.city}`;
  }
}
